import styled from 'styled-components';
import { Paragraph } from '@increasecard/typed-components';

export const LastParagraph = styled(Paragraph)`
  align-items: center;
  color: ${({ theme }) => theme.colorsNew.gray.blackSLight};
  display: flex;
  margin-top: auto;
  svg {
    color: ${({ theme }) => theme.colorsNew.card.light50};
    margin-right: 10px;
  }
`;
